import React from 'react';

export default function Paginacion({ paginaActual, totalPaginas, onCambiar }) {
  if (totalPaginas <= 1) return null;

  const paginas = Array.from({ length: totalPaginas }, (_, i) => i + 1);

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <small className="text-muted">
        Página {paginaActual} de {totalPaginas}
      </small>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onCambiar(paginaActual - 1)}
            >
              ‹
            </button>
          </li>
          {paginas.map((p) => (
            <li
              key={p}
              className={`page-item ${p === paginaActual ? 'active' : ''}`}
            >
              <button className="page-link" onClick={() => onCambiar(p)}>
                {p}
              </button>
            </li>
          ))}
          <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onCambiar(paginaActual + 1)}
            >
              ›
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}